import styled from "styled-components";
import { TextFont, Colors } from "../../config";
import { HeaderWrapper } from "../../pages/ConfirmBookingStatus";
import Box from "../Box";
import { getBookingStatusLabel } from "../../helper";

const JouryDetails = ({
  employeeJouryStatus,
  guestJouryStatus,
  companyContri,
  employeeContri,
  name,
  isBusinessTrip,
  rejectionReason,
}) => {
  const getImage = (imageName) => {
    return (
      <>
        <SuccessFailureImage
          src={require(`../../assets/images/${imageName}.png`)}
          alt="payment"
        />
      </>
    );
  };

  const displayJouryStatus = (status) => {
    switch (status) {
      case "Processing":
        return getImage("status_inProgress");
      case "Approved":
        return getImage("status_completed");
      case "On-Hold":
        return getImage("status_hold");
      case "Rejected":
        return getImage("status_cancelled");
      default:
        return;
    }
  };

  return (
    <>
      <HeaderWrapper>
        <TextFont fontColor={Colors.white} fontSize="1.5rem" fontWeight="800">
          Joury Details
        </TextFont>
      </HeaderWrapper>
      <StatusWrapper>
        {employeeJouryStatus && (
          <Box boxPadding="1.875rem 1.875rem 1.25rem">
            <BoxTab isBothAvailable={employeeJouryStatus && guestJouryStatus}>
              <Wrapper>
                <BoxTabEach>
                  <TextFont
                    fontColor={Colors.spanishGray}
                    fontSize="0.875rem"
                    fontWeight="500"
                  >
                    Employee Ticket Status
                  </TextFont>
                  <TextFont
                    fontColor={Colors.darkCharcoal}
                    fontSize="0.75rem"
                    fontWeight="500"
                  >
                    {getBookingStatusLabel(employeeJouryStatus)}
                  </TextFont>
                </BoxTabEach>
                {!isBusinessTrip && (
                  <BoxTabEach>
                    <TextFont
                      fontColor={Colors.spanishGray}
                      fontSize="0.875rem"
                      fontWeight="500"
                    >
                      Company Contribution
                    </TextFont>
                    <TextFont
                      fontColor={Colors.darkCharcoal}
                      fontSize="0.75rem"
                      fontWeight="500"
                    >
                      {companyContri ? `${companyContri} QAR` : "NA"}
                    </TextFont>
                  </BoxTabEach>
                )}
                {!isBusinessTrip && (
                  <BoxTabEach>
                    <TextFont
                      fontColor={Colors.spanishGray}
                      fontSize="0.875rem"
                      fontWeight="500"
                    >
                      Employee Contribution
                    </TextFont>
                    <TextFont
                      fontColor={Colors.darkCharcoal}
                      fontSize="0.75rem"
                      fontWeight="500"
                    >
                      {employeeContri ? `${employeeContri} QAR` : "NA"}
                    </TextFont>
                  </BoxTabEach>
                )}
                <BoxTabEach>
                  <TextFont
                    fontColor={Colors.spanishGray}
                    fontSize="0.875rem"
                    fontWeight="500"
                  >
                    Name
                  </TextFont>
                  <TextFont
                    fontColor={Colors.darkCharcoal}
                    fontSize="0.75rem"
                    fontWeight="500"
                  >
                    {name ? name : "NA"}
                  </TextFont>
                </BoxTabEach>
                {rejectionReason && (
                  <BoxTabEach>
                    <TextFont
                      fontColor={Colors.spanishGray}
                      fontSize="0.875rem"
                      fontWeight="500"
                    >
                      Cancellation Rejection Reason
                    </TextFont>
                    <TextFont
                      fontColor={Colors.darkCharcoal}
                      fontSize="0.75rem"
                      fontWeight="500"
                    >
                      {rejectionReason ? rejectionReason : "NA"}
                    </TextFont>
                  </BoxTabEach>
                )}
              </Wrapper>
              <ImageWrapper>
                {displayJouryStatus(employeeJouryStatus)}
              </ImageWrapper>
            </BoxTab>
          </Box>
        )}
        {guestJouryStatus && (
          <Box boxPadding="1.875rem 1.875rem 1.25rem">
            <BoxTab isBothAvailable={employeeJouryStatus && guestJouryStatus}>
              <BoxTabEach>
                <TextFont
                  fontColor={Colors.spanishGray}
                  fontSize="0.875rem"
                  fontWeight="500"
                >
                  Guest Ticket Status
                </TextFont>
                <TextFont
                  fontColor={Colors.darkCharcoal}
                  fontSize="0.75rem"
                  fontWeight="500"
                >
                  Completed
                </TextFont>
              </BoxTabEach>
              <ImageWrapper>
                {displayJouryStatus(guestJouryStatus)}
              </ImageWrapper>
            </BoxTab>
          </Box>
        )}
      </StatusWrapper>
    </>
  );
};

const BoxTab = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const BoxTabEach = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 14.5rem;
  width: -webkit-fill-available;
  margin: 0.5rem;
  margin-left: 0;
`;

const SuccessFailureImage = styled.img`
  width: 72px;
  height: 72px;
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StatusWrapper = styled.div`
  display: flex;
  gap: 1rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;
  flex-wrap: wrap;
`;
export default JouryDetails;
